<!-- eslint-disable complexity -->
<template>
    <div class="d-flex flex-column overflow-hidden">
        <b-form
            v-on:submit.prevent="$_onSubmit"
            class="d-flex flex-column overflow-hidden"
        >
            <div class="scrollable mb-3">
                <b-container>
                    <category
                        :categories="categories"
                        :accordion="true"
                        :inputFields="inputFields"
                        id="brk"
                        @onInput="$_validateInput($event)"
                        :invalidFieldValueErrorMessage="
                            invalidFieldValueErrorMessage
                        "
                    />
                </b-container>
            </div>
            <div v-if="invalidForm" class="errormsg px-4 mb-2">
                {{ invalidFormErrorMessage }}
            </div>
            <b-container>
                <b-row>
                    <b-col class="text-right pb-4">
                        <b-button variant="primary" type="submit">
                            <span>
                                {{ $t('searchButtonText') }}
                            </span>
                        </b-button>
                    </b-col>
                </b-row>
            </b-container>
        </b-form>
    </div>
</template>

<script>
    import brkApi from '../../../services/api/brk';
    import Category from './ApiCategory.vue';
    import { FIELD_TYPE } from '../../../constants';

    export default {
        components: { category: Category },
        data() {
            return {
                categories: [
                    {
                        label: this.$t('brk.searchCat1'),
                        category: 1,
                        expanded: true
                    },
                    {
                        label: this.$t('brk.searchCat2'),
                        category: 2,
                        expanded: false
                    },
                    {
                        label: this.$t('brk.searchCat3'),
                        category: 3,
                        expanded: false
                    },
                    {
                        label: this.$t('brk.searchCat4'),
                        category: 4,
                        expanded: false
                    },
                    {
                        label: this.$t('brk.searchCat5'),
                        category: 5,
                        expanded: false
                    },
                    {
                        label: this.$t('brk.searchCat6'),
                        category: 6,
                        expanded: false
                    }
                ],
                invalidFieldValueErrorMessage: '',
                invalidForm: false,
                invalidFormErrorMessage: '',
                inputFields: [
                    {
                        label: this.$t('brk.cadastralDesignation'),
                        key: 'kadastraleAanduiding',
                        value: '',
                        category: 1,
                        maxlength: 100,
                        pattern: '^([a-zA-Z0-9\'][a-zA-Z0-9\' ,\\-]*[a-zA-Z0-9]) ([A-IK-Z]{1,2}) ([1-9][0-9]{0,4})( A[1-9][0-9]{0,3})?$',
                        title: 'formaat: Beekbergen K 4826 (optioneel: A1)'
                    },
                    {
                        label: `${this.$t('brk.includeFromLegalDevision')} (optioneel)`,
                        key: 'inclusiefKadastraalOnroerendeZakenUitSplitsing',
                        value: null,
                        category: 1,
                        maxlength: 100,
                        domain: {
                            keyvalues: [
                                {
                                    value: 'true',
                                    text: this.$t('btnTitleYes')
                                },
                                {
                                    value: 'false',
                                    text: this.$t('btnTitleNo')
                                }
                            ]
                        }
                    },
                    {
                        label: this.$t('brk.citizenServiceNumber'),
                        key: 'burgerservicenummer',
                        value: '',
                        category: 2,
                        maxlength: 9,
                        pattern: '[0-9]{8}([0-9]{1})?',
                        title: '8 of 9 cijfers'
                    },
                    {
                        label: this.$t('brk.personIdentification'),
                        key: 'persoon__identificatie',
                        value: '',
                        category: 3,
                        maxlength: 16,
                        pattern: '[0-9]{16}',
                        title: '16 cijfers'
                    },
                    {
                        label: this.$t('brk.postalCode'),
                        key: 'postcode',
                        value: '',
                        category: 4,
                        maxlength: 6,
                        pattern: '[1-9][0-9]{3}(?!sa|sd|ss|SA|SD|SS)[A-Za-z]{2}',
                        title: 'formaat: 1234ab of 1234AB'
                    },
                    {
                        label: this.$t('brk.houseNumber'),
                        key: 'huisnummer',
                        value: null,
                        category: 4,
                        maxlength: 10,
                        type: FIELD_TYPE.NUMERIC
                    },
                    {
                        label: this.$t('brk.houseLetter'),
                        key: 'huisletter',
                        value: '',
                        category: 4,
                        maxlength: 100
                    },
                    {
                        label: this.$t('brk.houseNumberAddition'),
                        key: 'huisnummertoevoeging',
                        value: '',
                        category: 4,
                        maxlength: 4,
                        pattern: '^[0-9a-zA-Z]{1,4}$',
                        title: 'combinatie van hoofdletters, kleine letters en/of cijfers'
                    },
                    {
                        label: this.$t('brk.numberDesignation'),
                        key: 'nummeraanduidingIdentificatie',
                        value: '',
                        category: 5,
                        maxlength: 16,
                        pattern: '[0-9]{16}',
                        title: '16 cijfers'
                    },
                    {
                        label: this.$t('brk.cadastralDesignationWithMunicipalCode'),
                        key: 'kadastraleAanduidingMetGemeentecode',
                        value: '',
                        category: 6,
                        maxlength: 100,
                        pattern: '^([A-Z]{3}[0-9]{2}) ([A-IK-Z]{1,2}) ([1-9][0-9]{0,4})( A[1-9][0-9]{0,3})?$',
                        title: 'formaat: GVH00 C 1277 (optioneel: A3)'
                    },
                    {
                        label: `${this.$t('brk.includeFromLegalDevision')} (optioneel)`,
                        key: 'inclusiefKadastraalOnroerendeZakenUitSplitsing',
                        value: null,
                        category: 6,
                        maxlength: 100,
                        domain: {
                            keyvalues: [
                                {
                                    value: 'true',
                                    text: this.$t('btnTitleYes')
                                },
                                {
                                    value: 'false',
                                    text: this.$t('btnTitleNo')
                                }
                            ]
                        }
                    },
                ]
            };
        },
        methods: {
            async $_onSubmit() {
                let query = {};
                // Only add fields that have a value
                this.inputFields.forEach((item) => {
                    const value = typeof item.value === 'string' ? item.value.trim() : item.value;
                    if (value !== null &&
                        value !== '' &&
                        (item.category === this.$_categoryExpanded())
                    ) {
                        query[item.key] = value;
                        // Postal code input should be uppercase
                        if (item.key === 'postcode') {
                            query[item.key] = query[item.key].toUpperCase();
                        }
                    }
                });

                this.$store.commit('CLEAR_SELECTIONS');
                this.$store.commit('NEDGLOBE_MOBILE_DISPLAY_SELECTION_START');

                if (this.$_isValidForm(query)) {
                    this.errorData = null;
                    try {
                        const brkClient = await brkApi(this.$store);
                        const codResult = await brkClient.GetKadastraalOnroerendeZaken(query);

                        this.$store.dispatch('getBrkProperties', {
                            name: 'getBrkPropertiesData',
                            data: codResult.data,
                            title: this.$t('brk.cadastralProperties')
                        });

                        this.$emit('loading', false);
                    } catch (error) {
                        this.errorData = error.message;
                        console.log(
                            `Bad request: ${error.message} for /kadastraalonroerendezaken`
                        );
                        this.$store.commit('ADD_STATUS_MESSAGE', {
                            message:
                                'Er is een probleem met het vinden van het perceel in de BRK gegevens',
                            variant: 'danger',
                            autoHideDelay: 5000
                        });
                        this.$emit('loading', false);
                        throw error;
                    }
                }

                this.$store.commit('NEDGLOBE_MOBILE_DISPLAY_SELECTION_END');
            },

            // eslint-disable-next-line complexity
            $_missingSearchFieldsMessage(_query) {
                const query = JSON.parse(JSON.stringify(_query));
                if (!query) {
                    return this.$t('brk.missingSearchFields');
                }
                const nFields = Object.keys(query).length;

                // Error when all fields are empty
                if (nFields === 0) {
                    return this.$t('brk.missingSearchFields');
                } else if ((nFields === 1) && query['inclusiefKadastraalOnroerendeZakenUitSplitsing'] &&
                    (!query['kadastraleAanduiding'] && !query['kadastraleAanduidingMetGemeentecode'])) {
                    return this.$t('brk.incorrectFromLegalDevision');
                } else if ((this.$_categoryExpanded() === 4) && !(query['postcode'] && query['huisnummer'])) {
                    return this.$t('brk.incorrectPostalCodeHouseNumber');
                } else {
                    return '';
                }
            },

            $_isValidForm(query) {
                this.invalidForm = false;
                this.invalidFormErrorMessage =
                    this.$_missingSearchFieldsMessage(query);

                if (this.invalidFormErrorMessage) {
                    this.invalidForm = true;
                    return false;
                }

                if (this.$_hasInvalidStateFields(query)) {
                    this.invalidFormErrorMessage = this.$t(
                        'incorrectInputAllFields'
                    );
                    this.invalidForm = true;
                    return false;
                }
                return true;
            },
            $_hasInvalidStateFields(query) {
                const invalidFields = this.inputFields.filter(
                    ({ state }) => state === false
                );
                return invalidFields.length > 0;
            },
            $_validateInput(field) {
                if (field.type === undefined) {
                    field.state = !field.value.includes('*');
                    this.invalidFieldValueErrorMessage =
                        field.state === true || field.state === null
                            ? ''
                            : this.$t('brk.wildcarNotSupported');
                }
            },
            $_categoryExpanded() {
                return this.categories.findIndex((item) => item.expanded) + 1;
            }
        }
    };
</script>

<style scoped lang="scss">
.scrollable {
    overflow-y: auto;
}
</style>
